export const notInfinity = (n, fallback = 0) => (n === Infinity ? fallback : n);
